import LoremIpsum from 'react-lorem-ipsum';

const Quote = () => (
  <div className="quote">
    <h2>Quote of the day</h2>
    <LoremIpsum p={1} />
  </div>
);
export default Quote;
